import { ETypeParking, ILocation } from '../models';

export class Location {
  static isResidenceLocation(location: ILocation): boolean {
    return location.typeParking === ETypeParking.RESIDENCE;
  }
}
